import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import i18n from "i18next";
import PerformanceGroup from "../../../../groups/PerformanceGroup";

class MetricImpr extends MetricBase {
    constructor() {
        super({
            field: "metric_impr",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.trivago.impr.chartName"),
            serieLabel: i18n.t("metrics.trivago.impr.serieLabel"),
            tooltip: i18n.t("metrics.trivago.impr.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricImpr;
